/**
 * @name FiltersExpansion
 * @description Componente común de filtros con un panel de expansión
 * @author Ricardo Guerra
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Material-UI
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';

import { Icons, MUI } from '@styles';

class FiltersExpansion extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: props.defaultExpanded ? props.defaultExpanded : false,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.defaultExpanded !== this.props.defaultExpanded) {
      this.setState({ isExpanded: this.props.defaultExpanded });
    }
  }

  expandedHandler = () => {
    const { isExpanded } = this.state;
    this.setState({ isExpanded: !isExpanded });
  }

  render() {
    const { isExpanded } = this.state;
    const { children } = this.props;

    const Button = () => {
      return (
        <Styled.ButtonFilter
          type="button"
          color="primary"
        >
          <>
            <Icons.FilterList />
            <Styled.ArrowDownIcon expanded={isExpanded ? 1 : 0} />
          </>
        </Styled.ButtonFilter>
      );
    };

    return (
      <Styled.Accordion
        square
        expanded={isExpanded}
        onChange={this.expandedHandler}
      >
        <Styled.AccordionSummary
          expandIcon={<Button />}
          id="filters-report"
          aria-controls="filters-report"
          IconButtonProps={{
            disableRipple: true,
            disableFocusRipple: true
          }}
        >
        </Styled.AccordionSummary>
        <Styled.AccordionDetails>
          {children}
        </Styled.AccordionDetails>
      </Styled.Accordion>
    );
  }
}

FiltersExpansion.propTypes = {
  // Filters children, filtros a mostrar.
  children: PropTypes.node,
  // Boolean que indica si se muestra el accordion expandido.
  defaultExpanded: PropTypes.bool
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.ButtonFilter = styled(MUI.ButtonCTA)`
  &.MuiButton-containedPrimary {
    color: ${(props) => props.theme.colors.white};
    background-color: ${(props) => props.theme.colors.greyDark};
    box-shadow: ${(props) => props.theme.shadows.depth1};
    &:hover {
      background-color: ${(props) => props.theme.colors.greyDarkAlpha};
      box-shadow: ${(props) => props.theme.shadows.depth2};
    }
  }
`;

Styled.ArrowDownIcon = styled(Icons.ArrowDown)`
  font-size: 20px;
  transform: ${(props) => props.expanded ? 'rotate(180deg)' : 'rotate(0deg)'};
  transition: all 0.3s ease 0s;
`;

Styled.Accordion = styled(MuiAccordion)`
  &.MuiAccordion-root {
    background: none;
    box-shadow: none;
  }

  &.MuiAccordion-root:before {
    background: none;
  }
  
  &.MuiAccordion-root.Mui-expanded {
    margin: 0;
  }
`;

Styled.AccordionSummary = styled(MuiAccordionSummary)`
  &.MuiAccordionSummary-root {
    width: 136px;
    padding: 0px;
  }

  &.MuiAccordionSummary-root.Mui-expanded {
    min-height: 48px;
  }

  &.MuiAccordionSummary-root.Mui-focused {
    background: none;
  }

  .MuiAccordionSummary-content {
    display: none;
  }

  .MuiAccordionSummary-expandIcon {
    flex: 1;
    justify-content: flex-start;
    transform: none;
    padding: 0px
  }

  .MuiIconButton-root:hover {
    background: none;
  }

  .MuiIconButton-edgeEnd {
    margin: 0;
  }

  .MuiButtonBase-root {
    border-radius: 6px;
  }
`;

Styled.AccordionDetails = styled(MuiAccordionDetails)`
  &.MuiAccordionDetails-root {
    padding: 0px;
  }
`;

export default FiltersExpansion;